import React from 'react';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import { useNavigate } from 'react-router-dom';
import { alpha, styled } from '@mui/material/styles';
import { Box, Button, Stack, AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { useAuthenticated } from '../../services/hooks/';
import { MHidden } from '../../components/@material-extend';
import { Logo } from '../../components/landing/Logo';

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: '0px 3px 5px -1px rgba(51, 105, 30, 0.3),0px 5px 8px 0px rgba(0, 128, 0, 0.14),0px 1px 14px 0px rgba(0, 128, 0, 0.12)',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  color: '#18b500'
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 2)
  }
}));

export const LandingNavbar = () => {
  const navigate = useNavigate();
  const { token, group } = useSelector(state => state.app);
  const { isAuthenticated } = useAuthenticated();

  React.useEffect(() => {
    useAuthenticated();
  }, [token]);


  return (
    <RootStyle>
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton sx={{ mr: 1, color: 'text.primary' }}>
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>
        <Logo />
        <MHidden width="lgDown">
          <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
            <Box display="flex" flexDirection="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
              <IconButton onClick={() => navigate('/re/packages/')}>
                <Typography variant="button" color="primary">
                  OFERTA
                </Typography>
              </IconButton>
              <IconButton onClick={() => navigate('/re/packages/')}>
                <Typography variant="button" color="primary">
                  STREFA RODZICA
                </Typography>
              </IconButton>
              <IconButton onClick={() => navigate('/re/packages/')}>
                <Typography variant="button" color="primary">
                  WYSZUKIWARKA OBRAZÓW
                </Typography>
              </IconButton>
              <IconButton onClick={() => navigate('/re/packages/')}>
                <Typography variant="button" color="primary">
                  MOJE ULUBIONE OBRAZY
                </Typography>
              </IconButton>
              <IconButton onClick={() => navigate('/re/packages/')}>
                <Typography variant="button" color="primary">
                  PRACUJ Z NAMI
                </Typography>
              </IconButton>
              <IconButton onClick={() => navigate('/re/packages/')}>
                <Typography variant="button" color="primary">
                  ZAREZERWUJ
                </Typography>
              </IconButton>
            </Box>
            <Box>
              { isAuthenticated()
                ? <Button
                  color="primary"
                  variant="contained"
                  onClick={() => group == 'employees' || 'guests' ? navigate('/employee') : navigate('/client')}
                >
                Przejdź do aplikacji
                </Button>
                : <Button
                  color="primary"
                  variant="contained"
                  onClick={() => navigate('/login')}
                >
                Zaloguj się
                </Button>
              }
            </Box>
          </Box>
        </MHidden>
      </ToolbarStyle>
    </RootStyle>
  );
};
